import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
const ARROW_DOWN_SVG = 'https://cdn.magicpatterns.com/uploads/fnUgBgw9JsLfFkVun5pT6t/sj-website-arrow-down.svg';
const ARROW_UP_SVG = 'https://cdn.magicpatterns.com/uploads/hEP3R4hY8mUGp3Ag3crG84/sj-website-arrow-up.svg';
const ARROW_CIRCLE_SVG = 'https://cdn.magicpatterns.com/uploads/64QdFKsyFH5WUw2eGBDAHS/sj-website-arrow-circle.svg';
export function FAQSection() {
  const faqs = [{
    question: 'Where is your service area?',
    answer: "Our expert maids are available in Bicester and Oxfordshire. However, we are expanding our team and the area we cover every day so if you are not sure try booking online or call us. We'll confirm in seconds."
  }, {
    question: 'How to book a home or commercial cleaning?',
    answer: "If you're online, simply select the service you want and click the Book Online button to get personalised pricing, schedule an appointment in real-time based on our actual availability, and receive a confirmation. It only takes 60 seconds. Alternatively, call us at 01869 601439 or 07432 285564, or email us at smithsandjengs@yahoo.com."
  }, {
    question: 'Do I need to be at home when you arrive for the cleaning?',
    answer: "That's entirely up to you! If you've got other things to do, just let us know how we can get access to your home. Some customers provide a garage or door code, others leave a hidden key outside. Whatever works for you will work for us!"
  }, {
    question: 'Do I need to supply the vacuum or cleaning products?',
    answer: "We come equipped with everything we need to make your home or commercial facility sparkle. But if you'd prefer that we use your cleaning products, just let us know when you book online or by phone."
  }, {
    question: 'Do you use eco-friendly cleaning products?',
    answer: "Yes, we do! Part of our commitment as a member of the community is not to harm the environment. That's why we use only eco-friendly products which do just as good a cleaning job as traditional chemical cleaning products."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="bg-white py-24 md:py-32 relative z-20" data-id="element-72">
      <div className="container mx-auto px-6 md:px-12" data-id="element-73">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start" data-id="element-74">
          {/* Left FAQ Accordion */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-75">
            <div className="space-y-4" data-id="element-76">
              {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200 pb-4" data-id="element-77">
                  <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between py-4 text-left group" data-id="element-78">
                    <h3 className={`text-lg md:text-xl font-bold uppercase tracking-wide transition-colors duration-300 ${openIndex === index ? 'text-accent' : 'text-primary group-hover:text-accent'}`} data-id="element-79">
                      {faq.question}
                    </h3>
                    <img src={openIndex === index ? ARROW_UP_SVG : ARROW_DOWN_SVG} alt="" className="w-5 h-5 shrink-0 ml-4 transition-opacity duration-300" data-id="element-80" />
                  </button>
                  <AnimatePresence data-id="element-81">
                    {openIndex === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-82">
                        <p className="text-gray-600 leading-relaxed pb-4 pr-12" data-id="element-83">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>

            <div className="mt-12" data-id="element-84">
              <Link to="/faq" className="inline-flex items-center gap-4 text-primary font-bold uppercase tracking-widest hover:text-accent transition-colors group" data-id="element-85">
                Read all our FAQs
                <img src={ARROW_CIRCLE_SVG} alt="" className="w-12 h-12 group-hover:opacity-80 transition-opacity" data-id="element-86" />
              </Link>
            </div>
          </motion.div>

          {/* Right Heading & Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2 flex flex-col items-end text-right" data-id="element-87">
            <h2 className="text-6xl md:text-8xl lg:text-9xl font-heading font-bold text-primary uppercase leading-[0.85] tracking-tighter mb-12" data-id="element-88">
              Frequently <br data-id="element-89" /> Asked <br data-id="element-90" /> Questions
            </h2>

            <div className="relative w-full max-w-md h-[500px] rounded-2xl overflow-hidden shadow-xl" data-id="element-91">
              <img src="https://cdn.magicpatterns.com/uploads/w97pAeAsHvXpsZjJXJv9zy/bathroom-2.jpg" alt="Professional cleaner ready for service" loading="lazy" className="w-full h-full object-cover" data-id="element-92" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}